// Copyright 2019 Stanford University see LICENSE for license

import React from "react"
import PropTypes from "prop-types"
import Header from "../Header"
import TemplateSearch from "./TemplateSearch"
import AlertsContextProvider from "components/alerts/AlertsContextProvider"
import ContextAlert from "components/alerts/ContextAlert"
import { templateErrorKey } from "utilities/errorKeyFactory"
import PreviewModal from "../editor/preview/PreviewModal"

const ResourceTemplate = (props) => (
  <AlertsContextProvider value={templateErrorKey}>
    <section id="resourceTemplate">
      <Header triggerEditorMenu={props.triggerHandleOffsetMenu} />
      <ContextAlert />
      <PreviewModal />
      <TemplateSearch />
    </section>
  </AlertsContextProvider>
)

ResourceTemplate.propTypes = {
  children: PropTypes.array,
  triggerHandleOffsetMenu: PropTypes.func,
}

export default ResourceTemplate
